import React from "react";
import { Link } from "react-router-dom";
import "./Menu2.css";

var show = false;

class Menu extends React.Component {
  constructor() {
    super();
    this.state = {
      MenuLink: "Menu-Link-Hidden",
      show: false
    };
  }

  ShowMenu() {
    if (this.state.show) {
      this.setState({ show: false, MenuLink: "Menu-Link-Hidden" });
    } else {
      this.setState({ show: true, MenuLink: "Menu-Link" });
    }
  }

  checkStyle() {
    if (this.state && this.state.show) {
      if (document.body.clientWidth > 600) {
        this.setState({ show: false, MenuLink: "Menu-Link-Hidden" });
      }
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.checkStyle.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkStyle.bind(this));
  }

  render() {
    return (
      <div className="Menu2" id="Menu">
        <div className='LogoPanel2'>
          <Link to="/" className="Logo-Text2" onClick={() => this.setState({MenuLink: 'Menu-Link-Hidden'})}>
            <span className="logo-text-brand">Caigoy</span>
            <span className="logo-text-secondary">Creations</span>
          </Link>

          <div className="Menu-Navigation2">
            <div className="Hamburger" onClick={() => this.ShowMenu(show)}>
              <i className="fas fa-bars fa-lg"></i>
            </div>

            <Link to="/" className={this.state.MenuLink} onClick={() => this.setState({MenuLink: 'Menu-Link-Hidden'})}>
              HOME
            </Link>
            <Link
              to="/About-Us"
              className={this.state.MenuLink}
              style={{ minWidth: "87px" }}
              onClick={() => this.setState({MenuLink: 'Menu-Link-Hidden'})}
            >
              ABOUT US
            </Link>

            <Link to="/Products" className={this.state.MenuLink} onClick={() => this.setState({MenuLink: 'Menu-Link-Hidden'})} replace>
              PRODUCTS
            </Link>

            <Link
              exactPath
              to="/Products/Create"
              className={this.state.MenuLink}
              style={{ minWidth: "170px" }}
              onClick={() => this.setState({MenuLink: 'Menu-Link-Hidden'})}
            >
              CREATE PRODUCT
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;
